/**
 * mcgraw-hill: the HIPAA compliance mark under the AI desktop's composer, at
 * 60% so it sits back on the water. The wings are centred, not the image:
 * they span x 12–345 of the 500-wide artwork (centre 178.5) and the
 * "HIPAA COMPLIANCE" lettering hangs off to their right, so the image moves
 * right by (250 − 178.5) / 500 = 14.3% of its own width. Inverted in dark
 * mode, where its near-black ink would vanish.
 */
const McGrawHillHipaaBadge = () => (
  <div className="mt-2 flex justify-center min-[1200px]:-mt-2">
    <img
      alt="HIPAA compliance"
      className="h-8 w-auto translate-x-[14.3%] opacity-60 dark:invert"
      draggable={false}
      src="/instances/mcgraw-hill-hipaa.svg"
    />
  </div>
);

export default McGrawHillHipaaBadge;
